import SiteTopMenu from './SiteTopMenu.vue';
import SiteTopMenuDropdown from './SiteTopMenuDropdown.vue';
import SiteTopMobileMenu from './SiteTopMobileMenu.vue';
import SiteProfileMenuDropdown from './SiteProfileMenuDropdown.vue';
import { computed, ref, watch } from 'vue';
import { useDisplay } from 'vuetify';

function useSiteTopMenu() {
    const { mdAndUp } = useDisplay();
    const isMobile = computed(() => !mdAndUp.value);

    const mobileMenu = ref(false);
    const desktopMenu = ref();

    watch(isMobile, () => resetMenu());

    function resetMenu() {
        mobileMenu.value = false;
        desktopMenu.value = undefined;
    }

    return {
        mobileMenu,
        desktopMenu,
        resetMenu
    };
}

export { SiteTopMenu, SiteTopMenuDropdown, SiteTopMobileMenu, SiteProfileMenuDropdown, useSiteTopMenu };
